/**
 * @owner @Appboy/billing
 */

// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isContentCardsConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      app_group: string,
      card_type: string,
      total_unique_impressions: number,
      credit_ratio: number,
      credits_used: number,
      last_updated_at: number,
    })
  ),
});
